const en = {
  'helper.select.isSearchable': 'Start typing and select from the list',
  'helper.select.location.placeholder': 'E.g. San Francisco, California',
};

export default en;
